export enum SlideshowScreenAnimationEnum {
  WITHOUT = "WITHOUT",
  WITHOUT_AND_BLUR_BACKGROUND = "WITHOUT_AND_BLUR_BACKGROUND",
  FADE_IN_OUT = "FADE_IN_OUT",
  FADE_IN_OUT_AND_BLUR_BACKGROUND = "FADE_IN_OUT_AND_BLUR_BACKGROUND",
  FLY_IN_OUT = "FLY_IN_OUT",
  FLY_IN_OUT_AND_BLUR_BACKGROUND = "FLY_IN_OUT_AND_BLUR_BACKGROUND",
}
